import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { actions as ppcActions } from '../../../reducers/ppc.reducer';
import Modal from '../../modal/Modal.react';
import Form from '../../common/react-form/Form.react';
var PosPagesAdd = function PosPagesAdd(_ref) {
  var app = _ref.app;
  var dispatch = useDispatch();
  var formRef = useRef();
  return /*#__PURE__*/React.createElement(Modal, {
    title: "Add Page"
  }, /*#__PURE__*/React.createElement(Form, {
    ref: formRef,
    data: [{
      name: 'title',
      required: true
    }, {
      name: 'internalUrl',
      label: 'URL',
      required: true
    }],
    submitBtn: {
      label: 'Add',
      onSubmit: function onSubmit(formData) {
        formData.app = app;
        dispatch({
          type: ppcActions.page,
          payload: {
            formData: formData,
            method: 'post'
          }
        });
      }
    }
  }));
};
export default PosPagesAdd;